import { BaseRequest, IBaseRequest } from '../../BaseRequest';

export interface IListProfileRequest extends IBaseRequest {
    module: string;
}

export class ListProfileRequest extends BaseRequest implements IListProfileRequest {
    public module: string;

    constructor(server: string, session: string, module: string) {
        super(server, session);
        this.module = module;
    }

    public toXml(): string {
        var parameters: string = super.toXml();
        parameters += this.makeNode(this.module, 'module');

        return super.wrapperXml('ListProfile', parameters);
    }
}
